import InternalStaticAnchorLogin from 'models/application/anchor/types/internalStatic/types/Login';

export default class InternalStaticAnchorLoginService {
	toModel(anchor) {
		return new InternalStaticAnchorLogin(anchor);
	}
}
